import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Col,
  Row,
  Form,
  Container,
  Label,
  Input,
  Button,
} from "reactstrap"
import URLSearchParams from '@ungap/url-search-params'
// React Select
import Select from "react-select"
// MomentJS
import moment from "moment"
import SweetAlert from "react-bootstrap-sweetalert"
import _ from "lodash"

const PromoFormMerchant = (props) => {
  const [authToken, setAuthToken] = useState('')
  const [promo, setPromo] = useState(null)
  const [promoError, setPromoError] = useState(null)
  const [amount, setAmount] = useState(null)
  const [amountError, setAmountError] = useState(null)
  const [bundleCheck, setBundleChecked] = useState(false)
  const [noOfCodesCheck, setNoofCodesCheck] = useState(false)
  const [noOfCodesValue, setNoofCodesValue] = useState('')
  const [maxPerDayCheck, setMaxPerDayCheck] = useState(false)
  const [maxPerCampaignCheck, setMaxPerCampaignCheck] = useState(false)
  const [min_spend, setMinSpend] = useState(null)
  const [min_spendError, setMinSpendError] = useState('')
  const [max_discount, setMaxDiscount] = useState('')
  const [max_discountError, setMaxDiscountError] = useState('')
  const [min_quantity, setMinQuantity] = useState('')
  const [min_quantityError, setMinQuantitytError] = useState('')
  const [discountType, setDiscountType] = useState('amount')
  const [paymentMethod, setpaymentMethod] = useState('Visa')
  const [selectedMerchant, setSelectedMerchants] = useState([{label: "FRANK WILLIAMS", value: "22f03e66-bc4c-4c6c-81e1-c18671816658"}])
  const [selectedCategory, setSelectedCategory] = useState([])
  const [selectedProduct, setSelectedProduct] = useState([])  
  const [maxUsagePerDay, setMaxUsagePerDay] = useState(1)  
  const [maxUsagePerCampaign, setMaxUsagePerCampaign] = useState(1)  
  const [merchantOptions, setMerchantOptions] = useState([])
  const [categoryOptions, setCategoryOptions] = useState([])
  const [productOptions, setProductOptions] = useState([])
  const [noOfCodes, setnoOfCodes] = useState(null)
  const [noOfCodesError, setNoOfCodesError] = useState(null)
  const [success_msg, setsuccess_msg] = useState(false)
  const [errorMessage, SetErrorMessage] = useState('')
  const [errorMsgAlert, setErrorMsgAlert] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem("AuthenticationToken");
    setAuthToken(token)
    if(token !== ''){
      getMerchant(token)
      getCategories(token)
      getProducts(token)
    }
    return () => {
    }
  },[])

    const discountOptionGroup = [
        {
          options: [
            { label: "Fixed Amount Discount", value: "amount" },
            { label: "Percentage Discount", value: "percent" }
          ]
        }
      ]
      const maxUsageOptions = [
        {
          options: [
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "6", value: "6" },
            { label: "7", value: "7" },
            { label: "8", value: "8" },
            { label: "9", value: "9" },
            { label: "10", value: "10" },
            { label: "11", value: "11" },
            { label: "12", value: "12" },
            { label: "13", value: "13" },
            { label: "14", value: "14" },
            { label: "15", value: "15" },
            { label: "16", value: "16" },
            { label: "17", value: "17" },
            { label: "18", value: "18" },
            { label: "19", value: "19" },
            { label: "20", value: "20" },
            { label: "21", value: "21" },
            { label: "22", value: "22" },
            { label: "23", value: "23" },
            { label: "24", value: "24" },
            { label: "25", value: "25" },
            { label: "26", value: "26" },
            { label: "27", value: "27" },
            { label: "28", value: "28" },
            { label: "29", value: "29" },
            { label: "30", value: "30" },
          ]
        }
      ]
      const paymentOptionGroup = [
        {
          options: [
            { label: "Visa", value: "Visa" },
            { label: "Master Card", value: "MasterCard" },
            { label: "Grab Pay", value: "GrabPay" }
          ]
        }
      ]

      let merchantOptionGroup = []
      let categoryOptionGroup = []
      let productOptionGroup = []

  const getCurrentDate = () => {
      let date = moment(new Date()).format("YYYY-MM-DDTHH:MM")
      return date
  }
  const getMerchant = async (token) => {
    let auth = "Bearer " + token
    let _headers  = {
      "Content-Type":  "application/x-www-form-urlencoded",
      "Authorization": auth
    }   
    var requestOptions = {
      method: 'GET',
      headers: _headers,
      redirect: 'follow'
    };
    await fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/merchants`, requestOptions)
      .then(response => response.text())
      .then(result => {  
        let _data = JSON.parse(result)
        let tempArr = _.sortBy(_data.data, 'name')
        tempArr?.length > 0 && tempArr.map((item, index)=>{
          if(item.name !== '' && item.external_id !=='' && item.name.toLowerCase() !== "frx delivery"){
            merchantOptionGroup[index] = {label: `${item.name} (${item.email})`, value: item.external_id}
          }
        })
        setMerchantOptions(merchantOptionGroup)
      })
      .catch(error => console.log('error', error));
  }
  const getCategories = async (token) => {
    let auth = "Bearer " + token
    let _headers  = {
      "Content-Type":  "application/x-www-form-urlencoded",
      "Authorization": auth
    }   
    var requestOptions = {
      method: 'GET',
      headers: _headers,
      redirect: 'follow'
    };
    await fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/categories`, requestOptions)
      .then(response => response.text())
      .then(result => {
        let _data = JSON.parse(result)
        let tempArr = _.sortBy(_data.data, 'name')
        tempArr?.length > 0 && tempArr.map((item, index)=>{          
          if(item.name !== '' && item.external_id !==''){
            categoryOptionGroup[index] = {label: item.name, value: item.external_id}
          }
        })
        setCategoryOptions(categoryOptionGroup)
      })
      .catch(error => console.log('error', error));
  }

  const getProducts = async (token = '', merchant = [], category = []) => {
    let auth = 0;
    if(token!==''){
      auth = "Bearer " + token      
    }else{
      if(authToken!=='')
      auth = "Bearer " + authToken      
    }
    let selectMerchants = JSON.stringify(merchant)
    let selectCategories = JSON.stringify(category)
    
    let _headers  = {
      "Content-Type":  "application/x-www-form-urlencoded",
      "Authorization": auth
    }   
    var requestOptions = {
      method: 'GET',
      headers: _headers,
      redirect: 'follow'
    };


    let URl = '';
    if(merchant?.length > 0 && category?.length == 0){
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&merchant=${selectMerchants}`
    }else if(category?.length > 0 && merchant?.length == 0){
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&category=${selectCategories}`
    }
    else if(merchant?.length > 0 && category?.length > 0)
    {
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1&merchant=${selectMerchants}&category=${selectCategories}`
    }else{
      URl = `${process.env.REACT_APP_TOKRI_API_URL}/api/products?pageSize=-1`
    }
    
    await fetch(URl, requestOptions)
      .then(response => response.text())
      .then(result => { 
        let _data = JSON.parse(result)
        let tempArr = _.sortBy(_data, 'name')
        tempArr.length > 0 && tempArr.map((item, index)=>{
          if(item.name !== '' && item.name.toLowerCase() !== 'delivery' && item.external_id !==''){
            productOptionGroup[index] = {label: item.name, value: item.external_id}
          }
        })
        setProductOptions(productOptionGroup)
      })
      .catch(error => console.log('error', error));
  }

  function handleDiscountType(event) {
    setDiscountType(event.value)    
  }
  function handlePaymentInput(event){
      setpaymentMethod(event.value)
  }
  function handlePromoInput(e) {
      if(e.target.value.length < 25 && e.target.value.length > 0){
          setPromoError(false)
          setPromo(true)
      }
      else if(e.target.value.length === 24){
          setPromo(true)
          setPromoError(false)
      }else if(e.target.value.length === 0){
        setPromo(false)
        setPromoError(false)
      }
      else if(e.target.value.length > 24){
        setPromo(null)
        setPromoError(true)
      }
  }
  function handleNoCodesInput(e) {
    if(!noOfCodesCheck){
      var regex1 = /[A-Z]|[a-z]/g
      var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
      var str = e.target.value.toString()   
        setNoofCodesValue(e.target.value)      
        if(e.target.value == ''){
            setnoOfCodes(false)
            setNoOfCodesError(false)
          }
        else if(regex.test(str) && !regex1.test(str)){
          setnoOfCodes(true)
          setNoOfCodesError(false)
          }else if(!regex.test(str)){
            setnoOfCodes(null)
            setNoOfCodesError(true)
          }
        }
}
  function handleAmountInput(e) {
    var regex1 = /[A-Z]|[a-z]/g
    var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
    var str = e.target.value.toString()
      if(discountType == "amount"){      
        if(e.target.value == ''){
            setAmount(false)
            setAmountError(false)
          }
        else if(regex.test(str) && !regex1.test(str)){
            setAmount(true)
            setAmountError(false)
          }else if(!regex.test(str)){
            setAmount(null)
            setAmountError(true)
          }
      }
      else if(discountType == "percentage"){
        if(e.target.value == ''){
            setAmount(false)
            setAmountError(false)
          }
        else if(regex.test(str) && !regex1.test(str)){
            let percentage = parseFloat(str)
            if(percentage < 100){
               setAmount(true)
               setAmountError(false)
            }else{            
                setAmount(null)
                setAmountError(true)
            }
          }else if(!regex.test(str)){
            setAmount(null)
            setAmountError(true)
          }
      }
}

function handleMaxDiscountInput(e) {
  var regex1 = /[A-Z]|[a-z]/g
  var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
  var str = e.target.value.toString()
    if(discountType == "percentage"){
      if(e.target.value == ''){
          setMaxDiscount(false)
          setMaxDiscountError(false)
        }
      else if(regex.test(str) && !regex1.test(str)){
          let percentage = parseFloat(str)
          if(percentage < 100){
             setMaxDiscount(true)
             setMaxDiscountError(false)
          }else{            
              setMaxDiscount(null)
              setMaxDiscountError(true)
          }
        }else if(!regex.test(str)){
          setMaxDiscount(null)
          setMaxDiscountError(true)
        }
    }
}

function handleMinSpendInput(e) {
  var regex1 = /[A-Z]|[a-z]/g
  var regex = /[-+]?([0-9]*\.[0-9]+|[0-9]+)/g;
  var str = e.target.value.toString()
      if(e.target.value == ''){
          setMinSpend(false)
          setMinSpendError(false)
        }
      else if(regex.test(str) && !regex1.test(str)){
            setMinSpend(true)
            setMinSpendError(false)
        }else if(!regex.test(str)){
          setMinSpend(null)
          setMinSpendError(true)
        }
}
  function handleSubmit(e) {
    e.preventDefault();  
    var promo = document.getElementById("promocode-input").value
    var amount = document.getElementById("amount-input").value
    var st_date = document.getElementById("start_date_input").value
    var end_date = document.getElementById("end_date_input").value
    var min_spend = document.getElementById("minspend-input").value
    var min_quantity = document.getElementById("minquantity-input").value
    var quantityofCodes =  noOfCodesValue
    var tnc = document.getElementById("terms-and-conditions-input").value

    if (promo === '') {
      setPromo(false)
    }else {
        setPromo(true)
    }

    if (amount === "") {
      setAmount(false)
    } else {
      // var letters = "/\w|\W/g";
      setAmount(true)
    }
    if (quantityofCodes === "") {
      setnoOfCodes(false)
    } else {
      // var letters = "/\w|\W/g";
      setnoOfCodes(true)
    }

    // if (st_date === "") {
    //   setStartDate(false)
    // } else {
    //   setStartDate(st_date)
    // }

    // if (st_time === "") {
    //   setStartTime(false)
    // } else {
    //   setStartTime(st_time)
    // }

    // if (end_date === "") {
    //   setEndDate(false)
    // } else {
    //   setEndDate(end_date)
    // }

    // if (end_time === "") {
    //   setEndTime(false)
    // } else {
    //   setEndTime(end_time)
    // }

    if (min_spend === "") {
      setMinSpend(false)
    } else {
      setMinSpend(min_spend)
    }

    if (max_discount === "") {
      setMaxDiscount(false)
    } else {
      setMaxDiscount(max_discount)
    }
    var d1 = document.getElementsByName("validate")

    document.getElementById("tooltipForm").classList.add("was-validated")

    for (var i = 0; i < d1.length; i++) {
      d1[i].style.display = "block"
    }
    // post form data to api
    if(promo !== '' && amount !=='' && min_spend!=='' && min_quantity !== '' && (quantityofCodes !=='' || noOfCodesCheck)){
      createCampaign(
        promo, discountType, bundleCheck, amount, paymentMethod, st_date, end_date, quantityofCodes, noOfCodesCheck,
        maxUsagePerDay, maxPerDayCheck, maxUsagePerCampaign, maxPerCampaignCheck, min_spend, selectedMerchant, selectedCategory, selectedProduct, min_quantity, tnc
      )
    }
  }
  
  const createCampaign = (promo, type, bundle, 
    amount, payment, st_date, 
    end_date, noOfCodes, promoLimitCheck, 
    maxPerDay, maxPerDayCheck, maxPerCampaign, 
    maxPerCampaignCheck, min_spend, 
    merchant, category, 
    product, min_quantity, tnc) => {
    let token = localStorage.getItem("AuthenticationToken")
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Authorization", "Bearer " + token);
    
    var urlencoded = new URLSearchParams();
    urlencoded.append("marketplace_id", window.location.hostname == "tokri.spoonspace.com" ? "6a125896-1fe8-4fb0-9e13-8f45f1131d44" : "53fc4dac-490c-4dca-a255-dfc9c4310890");
    urlencoded.append("name", promo);
    urlencoded.append("discount_type", type ? type : "amount");
    if(bundle){
      urlencoded.append("bundle", 1);
    }else{
      urlencoded.append("bundle", 0);
    }
    urlencoded.append("discount_amount", amount);
    urlencoded.append("payment_method", payment);
    urlencoded.append("start_date", st_date);
    urlencoded.append("end_date", end_date);
    if(promoLimitCheck){
      urlencoded.append("max_promocodes_allocated", -1);
    }else{
      urlencoded.append("max_promocodes_allocated", noOfCodes);
    }
    if(maxPerDayCheck){
      urlencoded.append("max_limit_per_day", -1);
    }else{
      urlencoded.append("max_limit_per_day", maxPerDay);
    }
    if(maxPerCampaignCheck){
      urlencoded.append("max_limit_per_user", -1);
    }else{
      urlencoded.append("max_limit_per_user", maxPerCampaign);
    }
    urlencoded.append("min_spend", min_spend);
    if(discountType == "percent"){
      var max_discount = document.getElementById("max-discount-input").value
      urlencoded.append("max_discount", max_discount);
    }    
    urlencoded.append("discount_merchants", JSON.stringify(merchant));
    urlencoded.append("discount_categories", JSON.stringify(category));
    urlencoded.append("discount_products", JSON.stringify(product));
    urlencoded.append("min_quantity", min_quantity);
    urlencoded.append("discount_store_wide", 0);
    if(tnc!==''){
      urlencoded.append("tnc", tnc);
    }
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };
    fetch(`${process.env.REACT_APP_TOKRI_API_URL}/api/campaigns`, requestOptions)
      .then(response => response.json())
      .then(result => {
        if(result.message.toLowerCase() === "campaign record created"){
          setsuccess_msg(true)
        }else{
          SetErrorMessage(result.message)
          setErrorMsgAlert(true)
        }
      })
      .catch(error => console.log('Campaign Creation error', error));
  }
  const renderSuccessAlert = () => {
    return (
      <SweetAlert
        title="Success!"
        success
        confirmBtnBsStyle="success" 
        onConfirm={() => {
          setsuccess_msg(false)       
          props.props?.history.push("/merchant-dashboard")
        }}
        onCancel={() => {
          setsuccess_msg(false)
        }}
      >
        {"Campaign Created Successfully."}
      </SweetAlert>
    )
  }
  const renderFailureAlert = () => {
    return (
      <SweetAlert
        title="Warning!"
        warning        
        confirmBtnBsStyle="warning"
        onConfirm={() => {
          setErrorMsgAlert(false)
        }}
      >
        {errorMessage ? errorMessage : "Error. Something went wrong."}
      </SweetAlert>
    )
  }
  const handeBundleCheck = () => {
      setBundleChecked(!bundleCheck)
  }
  const handleNoofCodesCheck = () => {
    setNoofCodesCheck(!noOfCodesCheck)
}
const handleMaxPerDayCheck = () => {
  setMaxPerDayCheck(!maxPerDayCheck)
}
const handleMaxPerCampaignCheck = () => {
  setMaxPerCampaignCheck(!maxPerCampaignCheck)
}

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col lg={10} md={10} sm={10}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={10} md={10} sm={10}>
                      <div className="mt-5 mt-lg-4">
                        <Form 
                        className=""
                        method="post"
                        id="tooltipForm">
                          <div>
                            <Row>
                              <Col lg={6} md={6} sm={6}>
                              <div className="mb-4 position-relative">
                              <Label className="col-sm-8 col-form-label" htmlFor="formrow-firstname-input">Campaign Name</Label>
                              <Input type="text" className="form-control" id="promocode-input" 
                              onChange={e=>{handlePromoInput(e)}}                              
                              required
                              />    
                              {
                              promo == true ?
                              <div style={{color: "green", fontSize: 12}}>
                                  Looks Good!
                              </div>
                              :
                              promoError == true ?
                                <div style={{color: "red", fontSize: 12}}>
                                  Campaign name cannot be longer than 24 alphanumeric characters.
                                </div> 
                            :
                              promo == false &&
                              <div style={{color: "red", fontSize: 12}}>
                              Please enter Campaign Name.
                              </div>
                                
                              }
                              </div>
                              </Col>
                            </Row>
                            
                            <Row lg={12} md={12} sm={12}>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Discount Type</Label>
                              <Select
                                isSearchable={false}
                                value={discountType}
                                // isDisabled={bundleCheck}
                                onChange={(e) => {
                                  handleDiscountType(e)
                                }}
                                placeholder={discountType == '' ? "Select Discount Type" : (discountType == 'amount' ? "Fixed Amount" : "Percentage Amount")}
                                defaultValue={discountOptionGroup.length > 0 && discountOptionGroup[0].label}
                                options={discountOptionGroup}
                                required
                              />
                            </div>
                            </Col>
                            <Col lg={2} md={6} sm={6}>
                            <div className="form-check mb-12" style={{marginTop: 40, marginLeft: 10}}>
                            <input className="form-check-input-lg" type="checkbox" defaultChecked={bundleCheck} id="bundle-check"
                            onChange={()=>{handeBundleCheck()}}
                              />
                            <label className="form-check-label-lg" htmlFor="invalidCheck" style={{marginLeft: 5, fontSize: 14}}>
                            Bundle?
                            </label>
                          </div>
                            </Col>
                          </Row>
                          <Row>
                              <Col lg={6} md={6} sm={6}>
                              <div className="mb-3 position-relative">
                              <Label className="form-label" htmlFor="formrow-firstname-input">Amount({discountType == "amount" ? "$" : "%"})</Label>
                              <Input type="text" className="form-control" id="amount-input" 
                              onChange={e=>{handleAmountInput(e)}}
                              required/>
                              {amount == true &&
                              <div style={{fontSize: 12, color: "green"}}>
                                Looks good!
                              </div>}
                              {amount == false && 
                              <div className="invalid-feedback">
                                Please enter amount.
                              </div>}
                              {amountError == true &&
                              <div style={{color: "red", fontSize: 12, fontWeight: "300"}}>
                                Percentage or Amount is not valid.
                              </div>}
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                            <Col lg={5} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Payment Method</Label>
                              <Select
                                isSearchable={true}
                                value={paymentMethod}
                                onChange={(e) => {
                                  handlePaymentInput(e)
                                }}
                                placeholder={paymentMethod ? paymentMethod : "Select Payment Method"}
                                defaultValue={paymentOptionGroup.length > 0 && paymentOptionGroup[0].label}
                                options={paymentOptionGroup}
                                required
                              />
                            </div>
                            </Col>
                          </Row>
                          <Row>
                              <Col lg={6} md={6} sm={6}>
                              <div className="mb-3 position-relative">
                              <Label className="form-label" htmlFor="formrow-firstname-input">Start Date</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  defaultValue={getCurrentDate()}
                                  id="start_date_input"
                              />
                            </div>
                            </div>
                              </Col>
                            <Col lg={1}></Col>
                            <Col lg={5} md={6} sm={6}>
                            <div className="mb-3 position-relative">
                              <Label>End Date</Label>
                              <div className="col-md-12">
                                <input
                                  className="form-control"
                                  type="datetime-local"
                                  defaultValue={getCurrentDate()}
                                  id="end_date_input"
                              />
                            </div>
                            </div>
                            </Col>
                          </Row>
                          <Row lg={12} md={12} sm={12}>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3 position-relative">
                              <Label>No. of Promo Codes</Label>
                              <Input type="text" className="form-control" id="no-of-codes-input"
                              disabled={noOfCodesCheck}
                              value={noOfCodesCheck ? "" : noOfCodesValue}
                              onChange={e => {
                                handleNoCodesInput(e)
                              }}
                              required/>
                              {!noOfCodesCheck && noOfCodes == true &&
                              <div style={{fontSize: 12, color: "green"}}>
                                Looks good!
                              </div>}
                              {!noOfCodesCheck && noOfCodes == false && 
                              <div style={{color: "red", fontSize: 12, fontWeight: "300"}}>
                                Please enter no of codes.
                              </div>}
                              {!noOfCodesCheck && noOfCodesError == true &&
                              <div style={{color: "red", fontSize: 12, fontWeight: "300"}}>
                                No. of codes is not valid.
                              </div>}
                            </div>
                            </Col>
                            <Col lg={2} md={6} sm={4}>
                            <div className="form-check mb-8" style={{marginTop: 40, marginLeft: 10}}>
                            <input className="form-check-input-lg" type="checkbox" defaultChecked={noOfCodesCheck} id="no-of-promocode-check"
                            onChange={()=>{handleNoofCodesCheck()}}
                              required />
                            <label className="form-check-label-lg" htmlFor="invalidCheck" style={{marginLeft: 5, fontSize: 14}}>
                            No Limit?
                            </label>
                          </div>
                            </Col>
                          </Row>
                          <Row lg={12} md={12} sm={12}>
                            <Col lg={4} md={6} sm={6}>
                            <div className="mb-3 position-relative">
                              <Label>Max per user/per day</Label>
                              <Select
                                value={maxPerDayCheck ? "" : (maxUsagePerDay ? maxUsagePerDay : 0)}
                                placeholder={maxPerDayCheck ? "" : (maxUsagePerDay ? maxUsagePerDay : "Select max usage per day")} 
                                onChange={(e) => {
                                  setMaxUsagePerDay(e.value)
                                }}
                                options={maxUsageOptions}
                                isDisabled={maxPerDayCheck}
                                required
                              />
                            </div>
                            </Col>
                            <Col lg={2} md={4} sm={4}>
                            <div className="form-check mb-3" style={{marginTop: 40, marginLeft: 10}}>
                            <input className="form-check-input-lg" type="checkbox" defaultChecked={maxPerDayCheck} id="max-user-per-day-check"
                            onChange={()=>{handleMaxPerDayCheck()}}
                              required />
                            <label className="form-check-label-lg" htmlFor="invalidCheck" style={{marginLeft: 5, fontSize: 14}}>
                            No Limit?
                            </label>
                          </div>
                            </Col>
                            <Col lg={1}></Col>
                            <Col lg={3} md={6} sm={6}>
                            <div className="mb-6">
                              <Label>Max per user/per Campaign</Label>
                              <Select
                                value={maxPerCampaignCheck ? "" : (maxUsagePerCampaign ? maxUsagePerCampaign : 0)}
                                placeholder={maxPerCampaignCheck ? "" : (maxUsagePerCampaign ? maxUsagePerCampaign : "Select max usage per campaign")}                                
                                onChange={(e) => {
                                  setMaxUsagePerCampaign(e.value)
                                }}
                                isDisabled={maxPerCampaignCheck}
                                options={maxUsageOptions}
                              />
                            </div>
                            </Col>
                            <Col lg={2} md={4} sm={4}>
                            <div className="form-check mb-3" style={{marginTop: 40, marginLeft: 10}}>
                            <input className="form-check-input-lg" type="checkbox" defaultChecked={maxPerCampaignCheck} id="max-user-per-campaign-check"
                            onChange={()=>{handleMaxPerCampaignCheck()}}
                              required />
                            <label className="form-check-label-lg" htmlFor="invalidCheck" style={{marginLeft: 5, fontSize: 14}}>
                            No Limit?
                            </label>
                          </div>
                            </Col>
                          </Row>
                            <Row>
                              <Col lg={6} md={6} sm={6}>
                              <div className="mb-3 position-relative">
                              <Label className="form-label" htmlFor="formrow-firstname-input">Minimum Spend{discountType == "amount" && "($)"}</Label>
                              <Input type="text" className="form-control" id="minspend-input" 
                              onChange={e => {
                                handleMinSpendInput(e)
                              }}
                              required/>
                              {min_spend == true &&
                              <div style={{fontSize: 12, color: "green"}}>
                                Looks good!
                              </div>}
                              {min_spend == false && 
                              <div style={{fontSize: 12, color: "red"}}>
                                Please enter amount.
                              </div>}
                              {min_spendError == true &&
                              <div style={{color: "red", fontSize: 12, fontWeight: "300"}}>
                                Percentage or Amount is not valid.
                              </div>}
                            </div>
                              </Col>
                              <Col lg={1}></Col>
                              <Col lg={5} md={6} sm={6}>
                              {discountType == "percent" &&
                              <div className="mb-3 position-relative">
                              <Label className="form-label" htmlFor="formrow-firstname-input">Maximum Discount($)</Label>
                              <Input type="text" className="form-control" id="max-discount-input"
                              onChange={e => {
                                handleMaxDiscountInput(e)
                              }}
                              required/>
                              {max_discount == true &&
                              <div style={{fontSize: 12, color: "green"}}>
                                Looks good!
                              </div>}
                              {max_discount == false && 
                              <div style={{fontSize: 12, color: "red"}}>
                                Please enter maximum discount amount.
                              </div>}
                              {max_discountError == true &&
                              <div style={{color: "red", fontSize: 12, fontWeight: "300"}}>
                                Percentage or Amount is not valid.
                              </div>}
                            </div>}
                              </Col>
                            </Row>                            
                            <Row>
                            {/* <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Merchant</Label>
                              <Row>
                              <Col>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setSelectedMerchants(e)
                                  if(authToken !== '')
                                  getProducts(authToken, e)                               
                                }}
                                placeholder={"Select Merchant"}
                                defaultValue={merchantOptionGroup.length > 0 && merchantOptionGroup[0].label}
                                options={merchantOptions}                                
                                isMulti
                              />
                              </Col>
                              </Row>
                            </div>
                            </Col> */}
                          </Row>
                          {/* <Row>
                            <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Category</Label>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setSelectedCategory(e)
                                  if(authToken !== ''){
                                    if(selectedMerchant){
                                      getProducts(authToken, selectedMerchant, e)
                                    }else{
                                      getProducts(authToken, [], e)
                                    }
                                    
                                  }
                                }}
                                placeholder={"Select Category"}
                                defaultValue={categoryOptionGroup.length > 0 && categoryOptionGroup[0].label}
                                options={categoryOptions}
                                isMulti
                              />
                            </div>
                            </Col>
                          </Row> */}
                          <Row>
                            <Col lg={6} md={6} sm={6}>
                            <div className="mb-3">
                              <Label>Product</Label>
                              <Select
                                isSearchable={true}
                                onChange={(e) => {
                                  setSelectedProduct(e)
                                }}
                                placeholder={"Select Product"}
                                defaultValue={productOptionGroup.length > 0 && productOptionGroup[0].label}
                                options={productOptions}
                                isMulti
                              />
                            </div>
                            </Col>
                            <Col lg={1}></Col>
                            <Col lg={5} md={6} sm={6}>
                            <div className="mb-3 position-relative">
                              <Label>Minimum Quantity</Label>
                              <Input type="text" className="form-control" id="minquantity-input" 
                              onChange={e=>{
                                if(e.target.value == ''){
                                  setMinQuantity(false)
                                  setMinQuantitytError(false)
                                }
                                else if(isNaN(parseInt(e.target.value))){
                                  setMinQuantity(null)
                                  setMinQuantitytError(true)
                                }else if(!isNaN(parseInt(e.target.value))){
                                  setMinQuantity(true)
                                  setMinQuantitytError(false)
                                }
                              }}
                              required/>
                            </div>
                              {min_quantity == false && 
                              <div className="invalid-feedback">
                                Please enter quantity.
                              </div>}
                              {min_quantityError == true &&
                              <div style={{color: "red", fontSize: 12, fontWeight: "300"}}>
                                Quantity is not valid.
                              </div>}
                            </Col>
                          </Row>
                          <Row>
                              <Col lg={6} md={6} sm={6}>
                              <div className="mb-4 position-relative">
                              <Label className="col-sm-8 col-form-label" htmlFor="formrow-firstname-input">{"Terms & Conditions"}</Label>
                              <Input type="textarea" className="form-control" id="terms-and-conditions-input"             
                              required
                              />
                              </div>
                              </Col>
                            </Row>
                          {success_msg ? (
                            renderSuccessAlert()
                          ) 
                          :
                          null 
                          }
                          {errorMsgAlert ? (
                            renderFailureAlert()
                          )
                          :
                          null
                          }
                          <div className="text-center mt-4">
                            <Button type="submit" color="primary" className="btn btn-primary waves-effect waves-light"
                            onClick={e=>{handleSubmit(e)}}
                            >Create Campaign</Button>
                          </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PromoFormMerchant;
